/**
*
* RedOurTeamMember
*
*/

import React from 'react';
import PropTypes from 'prop-types';



import Wrapper from 'components/Templates/dynamics/Wrapper';

import defaultTextValues from './defaultTextValues';


function RedOurTeamMember(props) {

  const {
    commonData,
    commonProps,
    memberId
  } = props;

  const memberIcons = (
    <Wrapper
      {...commonProps}
      typeOfStyle={'memberIcons'+memberId}
      
      editorData={
        {
          editorType: 'memberIcons',
          ...commonData
        }
      }
    >
      <Wrapper
        {...commonProps}
        typeOfStyle={'memberLinkedinIcon'}
        
        target={'_blank'}
        editorData={
          {
            editorType: 'memberLinkedinIcon'+memberId,
            ...commonData
          }
        }
      />
        <Wrapper
          {...commonProps}
          typeOfStyle={'memberFacebookIcon'+memberId}
          
          target={'_blank'}
          editorData={
            {
              editorType: 'memberFacebookIcon'+memberId,
              ...commonData
            }
          }
        />
          <Wrapper
            {...commonProps}
            typeOfStyle={'memberInstagramIcon'+memberId}
            
            target={'_blank'}
            editorData={
              {
                editorType: 'memberInstagramIcon'+memberId,
                ...commonData
              }
            }
          />

          <Wrapper
            {...commonProps}
            typeOfStyle={'memberTwitterIcon'+memberId}
            
            target={'_blank'}
            editorData={
              {
                editorType: 'memberTwitterIcon'+memberId,
                ...commonData
              }
            }
          />
          <Wrapper
            {...commonProps}
            typeOfStyle={'memberWWWIcon'+memberId}
            
            target={'_blank'}
            editorData={
              {
                editorType: 'memberWWWIcon'+memberId,
                ...commonData
              }
            }
          />

    </Wrapper>
  );

  const details =
    (<>
      <Wrapper
        {...commonProps}
        typeOfStyle={'name'+memberId}
        defaultValues={defaultTextValues}
        type={'text'}
        
        editorData={
          {
            editorType: 'name'+memberId,
            ...commonData
          }
        }
      />

    <Wrapper
      {...commonProps}
      
      typeOfStyle={'memberDesc'+memberId}
      type={'text'}
      defaultValues={defaultTextValues}
      editorData={
        {
          editorType: 'memberDesc'+memberId,
          ...commonData
        }
      }
    ></Wrapper>
    <Wrapper
        {...commonProps}
        typeOfStyle={'contactHorizontalWrapper'}
        
        editorData={
          {
            editorType: 'contactHorizontalWrapper',
            ...commonData
          }
        }
      >
        <Wrapper
          {...commonProps}
          typeOfStyle={'memberDot'}
          
          target={'_blank'}
          editorData={
            {
              editorType: 'memberDot',
              ...commonData
            }
          }
        >
          ⬤
        </Wrapper>
        <Wrapper
          {...commonProps}
          typeOfStyle={'memberEmail'+memberId}
          
          defaultValues={defaultTextValues}
          type={'text'}
          editorData={
            {
              editorType: 'memberEmail'+memberId,
              ...commonData
            }
          }
        />
      </Wrapper>
      <Wrapper
        {...commonProps}
        typeOfStyle={'contactHorizontalWrapper'}
        
        editorData={
          {
            editorType: 'contactHorizontalWrapper',
            ...commonData
          }
        }
      >
        <Wrapper
          {...commonProps}
          typeOfStyle={'memberDot'}
          
          target={'_blank'}
          editorData={
            {
              editorType: 'memberDot',
              ...commonData
            }
          }
        >
          ⬤
        </Wrapper>
        <Wrapper
          {...commonProps}
          typeOfStyle={'memberPhone'+memberId}
          
          defaultValues={defaultTextValues}
          type={'text'}
          editorData={
            {
              editorType: 'memberPhone'+memberId,
              ...commonData
            }
          }
        />
      </Wrapper>
    {memberIcons}
    </>);

  return (
    <Wrapper
      {...commonProps}
      
      typeOfStyle={'memberContainer'}
      editorData={
        {
          editorType: 'memberContainer',
          ...commonData
        }
      }
    >
      <Wrapper
        {...commonProps}
        
        typeOfStyle={'memberAvatar'+memberId}
        editorData={
          {
            editorType: 'memberAvatar'+memberId,
            ...commonData
          }
        }
      >
      </Wrapper>
      {details}
    </Wrapper>
  );

}

RedOurTeamMember.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
  members: PropTypes.array,
  setShowPopup: PropTypes.func,
  defaultValues: PropTypes.object,
  memberCompany: PropTypes.object,
};

export default RedOurTeamMember;
